import React from "react";
import { Box, Typography, Card, CardContent } from "@mui/material";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import "../../styles/_videoContent.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
const VideoContentSection = () => {
  const { t } = useTranslation();
  // Fetch dynamic array from JSON
  const content = t("videoContent", { returnObjects: true });
  const cards = content.cards || [];

  const testimonials = t("testimonials.list", { returnObjects: true });

  return (
    <Box sx={{ backgroundColor: "#fff", py: { xs: 6, md: 10 }, color: "#000" }}>
      {/* 🔹 About Gurudev Section – Dynamic Card Grid */}
      <Box sx={{ px: { xs: 2, md: 8 }, mb: 10 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            mb: 4,
            textAlign: "center",
            color: "#000",
            textShadow: "0 0 6px rgba(255, 215, 0, 0.3)",
          }}
        >
          {content.title}
        </Typography>

        {/* Dynamic Cards */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",          // Mobile: 1 card
              sm: "1fr 1fr",      // Tablet: 2 cards
              md: "1fr 1fr 1fr",  // Desktop: 3 cards
            },
            gap: "40px 25px", // 💥 More space between rows + columns
            justifyItems: "center",
          }}
        >
          {cards.map((item, idx) => (
            <Card
              key={idx}
              sx={{
                width: "100%",
                maxWidth: "100%",
                borderRadius: "20px",
                overflow: "hidden",
                backgroundColor: "#000",
                boxShadow: "0 0 20px rgba(255,215,0,0.4)",
                transition: "0.3s",
                margin: "0 auto",
                "&:hover": { transform: "translateY(-6px)" },
              }}
            >
              <img
                src={item.image}
                alt={item.title}
                style={{
                  width: "100%",
                  height: "240px",
                  objectFit: "contain",
                  display: "block",
                }}
              />

              <CardContent sx={{ textAlign: "center" }}>
                <Typography
                  sx={{
                    color: "#FFD700",
                    fontSize: "1.1rem",
                    fontWeight: 700,
                  }}
                >
                  {item.title}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Box>

  {/* 💬 Testimonials Section */}
<Box sx={{ px: { xs: 2, md: 8 }, textAlign: "center" }}>
  <Typography
    variant="h4"
    sx={{
      fontWeight: 700,
      mb: 5,
      color: "#000",
      textShadow: "0 0 6px rgba(255, 215, 0, 0.3)",
    }}
  >
    {t("testimonials.title")}
  </Typography>

  <Swiper
    modules={[Navigation, Pagination]}
    spaceBetween={24}
    navigation
    pagination={{ clickable: true }}
    grabCursor
    style={{ paddingBottom: "40px" }}
    breakpoints={{
      0: {
        slidesPerView: 1,
      },
      600: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
    }}
    className="testimonial-swiper"
  >
    {testimonials.map((testimonial, index) => (
      <SwiperSlide key={index}>
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <Card
            sx={{
              backgroundColor: "#000",
              color: "#FFD700",
              borderRadius: "16px",
              overflow: "hidden",
              width: "100%",
              maxWidth: "360px",
              margin: "0 auto",
              boxShadow: "0 0 20px rgba(255, 215, 0, 0.4)",
              transition: "0.3s",
              "&:hover": {
                transform: "translateY(-6px)",
              },
            }}
          >
            {/* Video */}
            <video
              src={testimonial.video}
              controls
              preload="metadata"
              playsInline
              style={{
                width: "100%",
                height: "220px",
                objectFit: "cover",
                display: "block",
              }}
            />

            {/* Name & Place */}
            <CardContent>
              <Typography
                variant="h6"
                sx={{ fontWeight: 600, color: "#FFD700", mb: 0.5 }}
              >
                {testimonial.name}
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "#fff", fontSize: "0.9rem" }}
              >
                {testimonial.place}
              </Typography>
            </CardContent>
          </Card>
        </motion.div>
      </SwiperSlide>
    ))}
  </Swiper>
</Box>

    </Box>
  );
};

export default VideoContentSection;